import { render, staticRenderFns } from "./CommitteeActionDialog.vue?vue&type=template&id=b61ded92&scoped=true"
import script from "./CommitteeActionDialog.vue?vue&type=script&lang=js"
export * from "./CommitteeActionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61ded92",
  null
  
)

export default component.exports